export default function language(state = 'en-US') { return state; }



// WEBPACK FOOTER //
// ./data/Language/reducer.js